module.exports = __webpack_public_path__ + "a8ffa7918ed6562ce5bc7d1e017cb0a3.png";